import React from "react";
import { TableHeader } from "./survey-summary";
import { copyTableAsPng } from "../copy-table-image";
import { Table } from "./table";

type AnalyticalSummaryCardProps = {
    title: string;
    tableData: any[];
    columns: any[];
    onRowClick: (row: any) => void;
};

export const AnalyticalSummaryCard = ({
    title,
    tableData,
    columns,
    onRowClick,
}: AnalyticalSummaryCardProps) => {
    const tableRef = React.useRef<HTMLDivElement | null>(null);

    return (
        <div className="w-100 overflow-x-scroll">
            <div className="mb-2 flex items-center justify-between gap-2">
                <TableHeader title={title} />
                <button
                    type="button"
                    className="rounded bg-gray-700 px-2 py-1 text-xs text-white"
                    onClick={async () => {
                        if (!tableRef.current) return;
                        try {
                            await copyTableAsPng(tableRef.current);
                        } catch (error) {
                            console.error("Failed to copy table as PNG", error);
                        }
                    }}
                >
                    Copy as PNG
                </button>
            </div>
            <div ref={tableRef}>
                <Table data={tableData} columns={columns} onRowClick={onRowClick} />
            </div>
        </div>
    );
};
